// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"Notifications_notificationsContainer__3xvS4","title":"Notifications_title__270Z6","item":"Notifications_item__22z3_"};